<div class="content-wrapper">
    <h1>Improve retention levels</h1>
    <h2>A welcoming and effective induction is central to ensuring a positive first impression of your organisation</h2>
    <div class="centering">
        <div class="button1" (click)="findOutMore();">Find out more</div>
    </div>
</div>